import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box } from 'braid-design-system';

import AddAttachmentItem from 'src/components/details/Attachments/AddAttachmentItem';
import CreateNoteFormProvider from 'src/components/details/Notes/CreateNoteForm';
import { APPLIED } from 'src/constants/sourceId';

import translations from '../.vocab';

interface Props {
  showServerError: boolean;
  isLoading: boolean;
  locale: Locale;
  onAddNote: (content: string) => Promise<void>;
  addAttachmentAction: (
    content: File,
  ) => Promise<'done' | 'error' | 'validation_error'>;
  onAddAttachmentClick: () => void;
  source: number;
}

export const AddNotesAttachments = ({
  showServerError,
  isLoading,
  locale,
  onAddNote,
  addAttachmentAction,
  onAddAttachmentClick,
  source,
}: Props) => {
  const { t } = useTranslations(translations);

  const isSeekApply = source === APPLIED;

  return (
    <>
      <Stack space="medium">
        <Heading level="4">{t('Notes')}</Heading>
        <CreateNoteFormProvider
          showServerError={showServerError}
          loading={isLoading}
          onAdd={onAddNote}
          locale={locale}
        />
      </Stack>
      {isSeekApply && (
        <Stack space="medium">
          <Heading level="4">{t('Attachments')}</Heading>
          <Box>
            <AddAttachmentItem
              addAttachmentAction={addAttachmentAction}
              onAddAttachmentClick={onAddAttachmentClick}
            />
          </Box>
        </Stack>
      )}
    </>
  );
};
